import { render } from "./FaqQuestionCard.vue?vue&type=template&id=0dbc98d4&scoped=true"
import script from "./FaqQuestionCard.vue?vue&type=script&lang=js"
export * from "./FaqQuestionCard.vue?vue&type=script&lang=js"

import "./FaqQuestionCard.vue?vue&type=style&index=0&id=0dbc98d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbc98d4"]])

export default __exports__